import {
    type TextStyle,
    StyleSheet,
    Platform
} from "react-native";
import {
    type TextAreaInputCounterConstantType,
    type TextAreaInputDynamicStyleType,
    type TextAreaInputTypeConstantType,
    type TextAreaInputCounter,
    type TextAreaInputType
} from "./type";
import type {
    Mutable
} from "../../types";
import type {
    FieldType
} from "../fieldControl/type";
import {
    formatNumber
} from "../../helpers/locale/format";
import {
    webStyle
} from "../../utils";

export const TEXT_AREA_INPUT_TYPES: Record<TextAreaInputType, FieldType> = {
    question: "neutral",
    default: "neutral",
    neutral: "neutral",
    success: "success",
    warning: "warning",
    danger: "danger",
    info: "info"
};

export const TEXT_AREA_INPUT_COUNTER_LIVE_RATIO = 0.9;

export const getTextAreaInputType = ({
    type
}: TextAreaInputTypeConstantType): FieldType => {
    return TEXT_AREA_INPUT_TYPES[type];
};

export const getTextAreaInputCounter = ({
    maxLength,
    length,
    locale
}: TextAreaInputCounterConstantType): TextAreaInputCounter => {
    return {
        isWarning: length >= maxLength * TEXT_AREA_INPUT_COUNTER_LIVE_RATIO && length < maxLength,
        isLive: length >= maxLength * TEXT_AREA_INPUT_COUNTER_LIVE_RATIO,
        isFull: length >= maxLength,
        isOver: length > maxLength,
        text: `${formatNumber({
            value: length,
            locale
        })} / ${formatNumber({
            value: maxLength,
            locale
        })}`
    };
};

export const getIsFieldSizingSupported = (): boolean => {
    if(Platform.OS !== "web" || typeof CSS === "undefined" || typeof CSS.supports !== "function") {
        return false;
    }

    return CSS.supports("field-sizing", "content");
};

const stylesheet = StyleSheet.create({
    input: {
        backgroundColor: "transparent",
        includeFontPadding: false,
        textAlignVertical: "top",
        alignSelf: "stretch",
        borderWidth: 0,
        minWidth: 0,
        padding: 0,
        margin: 0,
        flex: 1,
        ...webStyle({
            fieldSizing: "content"
        })
    }
});

export const useStyles = ({
    contentHeight
}: TextAreaInputDynamicStyleType) => {
    const styles = {
        input: {
        } as Mutable<TextStyle>
    };

    if(contentHeight !== undefined) {
        styles.input.height = contentHeight;
    }

    return styles;
};
export default stylesheet;
